<template>
  <div ref="container" v-show="false">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  props: {
    textSize: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 26
    }
  },
  methods: {
    generate (text) {
      const context = this.$refs.canvas.getContext('2d')
      context.font = `${this.textSize}px serif`
      context.canvas.width = context.measureText(text).width
      context.canvas.height = this.height
      context.font = `${this.textSize}px serif`
      context.fillText(text, 0, this.textSize - 3)
      return context.canvas.toDataURL()
    }
  }
}
</script>


// WEBPACK FOOTER //
// LinkGenerator.vue?7742c21a